import {
  Analytics32,
  Blockchain32,
  ChartBarStacked32,
  HeatMapStocks32,
  Table32,
  TableBuilt32
} from '@carbon/icons-react'
import FeedbackUtente from 'pages/ExtraOutput/FeedbackUtente'
import OccupazioneSpazi from 'pages/ExtraOutput/OccupazioneSpazi'
import DashboardNowcasting from 'pages/Output/DashboardNowcasting'
import DashboardOperativa from 'pages/Output/DashboardOperativa'
import ReportPivot from 'pages/Output/ReportPivot'
import Similarity from 'pages/Output/Similarity'
import TabellaDettaglio from 'pages/Output/TabellaDettaglio'

const outputConfigComponents = {
  DashboardNowcasting: {
    component: DashboardNowcasting,
    icon: Blockchain32,
    filterBar: true
  },
  DashboardOperativa: {
    component: DashboardOperativa,
    icon: Analytics32,
    filterBar: true
  },
  TabellaDettaglio: {
    component: TabellaDettaglio,
    icon: Table32,
    filterBar: true
  },
  ReportPivot: {
    component: ReportPivot,
    icon: TableBuilt32,
    filterBar: true
  },
  Similarity: {
    component: Similarity,
    icon: 'none',
    filterBar: false
  },
  OccupazioneSpazi: {
    component: OccupazioneSpazi,
    icon: HeatMapStocks32,
    filterBar: true
  },
  FeedbackUtente: {
    component: FeedbackUtente,
    icon: ChartBarStacked32,
    filterBar: true
  }
}

export default outputConfigComponents

export const outputConfigRoutes = {
  children: [
    {
      path: '/DashboardOperativa',
      component: 'DashboardOperativa',
      title: 'SideNavigation.DASHBOARD_OPERATIVA'
    },
    {
      path: '/TabellaDettaglio',
      component: 'TabellaDettaglio',
      title: 'SideNavigation.TABELLA_DETTAGLIO'
    },
    {
      path: '/OccupazioneSpazi',
      component: 'OccupazioneSpazi',
      title: 'SideNavigation.SPACE_OCCUPANCY',
      extraOutputSidebar: true,
      onlyGroupLink: true,
      headerGroup: 'Store Collaboration',
      type: 'extraOutput'
    },
    {
      path: '/FeedbackUtente',
      component: 'FeedbackUtente',
      title: 'SideNavigation.USER_FEEDBACK',
      extraOutputSidebar: true,
      onlyGroupLink: true,
      headerGroup: 'Store Collaboration',
      type: 'extraOutput'
    }
  ],
  sidebar: false
}
